import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/home/Hero";
import Features from "@/components/home/Features";
import HowItWorks from "@/components/home/HowItWorks";
import ROICalculator from "@/components/home/ROICalculator";
import VacationRentalUseCase from "@/components/home/VacationRentalUseCase";
import CampaignManager from "@/components/home/CampaignManager";
import AnalyticsReporting from "@/components/home/AnalyticsReporting";
import Testimonials from "@/components/home/Testimonials";
import Pricing from "@/components/home/Pricing";
import CallToAction from "@/components/home/CallToAction";
import FAQ from "@/components/home/FAQ";
import BlogPreview from "@/components/home/BlogPreview";
import Integrations from "@/components/home/Integrations";
import CustomerExperienceOwnership from "@/components/home/CustomerExperienceOwnership";
import UseCaseShowcase from "@/components/use-cases/UseCaseShowcase";
import SEOHead from "@/components/seo/SEOHead";
import StructuredData from "@/components/seo/StructuredData";
import { useTranslation } from "@/hooks/useTranslation";

const Index = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEOHead
        title={t("seo.home.title" as any)}
        description={t("seo.home.description" as any)}
        keywords={t("seo.home.keywords" as any)}
        canonicalPath="/"
      />
      <StructuredData type="organization" />
      <StructuredData 
        type="product" 
        data={{ 
          productDescription: t("seo.home.description" as any) 
        }} 
      />
      <Navbar />
      <main>
        <Hero />
        <Testimonials />
        <Features />
        <HowItWorks />
        <ROICalculator />
        <VacationRentalUseCase />
        <UseCaseShowcase />
        <CallToAction />
        <CampaignManager />
        <AnalyticsReporting />
        <Integrations />
        <CustomerExperienceOwnership />
        <Pricing />
        <FAQ />
        <BlogPreview />
      </main>
      <Footer />
    </>
  );
};

export default Index;
